module.exports = __webpack_public_path__ + "7964c0533880b85d066989504c6ff7ff.png";